import $ from "jquery";
import Constants from "../business/Constants";
import GigyaManager from "../business/GigyaManager";
import RestManager from "../business/RestManager";
import { SmartComponent } from "smart-component-js";
import productData from "../data/product";
import storeOffline from "../data/store_offline";
import storeOnline from "../data/store_online";

class CompletaDatiCtrl extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.alphanumReg = /^[A-Za-z0-9 ']+$/;
    this.regexNomi = /^[a-zA-ZàáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð .'-]+$/;
    this.numberReg = /^[0-9]+$/;
    this.capReg = /\b\d{5}\b/;
    this.regexAddress = /^[a-zA-Z0-9àáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð ,.'-/°]+$/;
    this.regexCity = /^[a-zA-ZàáâäãåèéêëìíîïòóôöõøùúûüÿýñçčšžÀÁÂÄÃÅÈÉÊËÌÍÎÏÒÓÔÖÕØÙÚÛÜŸÝÑßÇŒÆČŠŽ∂ð ,.'-/°]+$/;
    this.centReg = /^[0-9]{2}$/;
    this.files = [];
    this.init();
  }
  init() {
    this.loadChildComponents(this);
    this.startLoader();

    // Make sure that #prize-destination is not already checked if exists
    if ($("#prize-destination").length)
      $("#prize-destination").prop("checked", false);

    let play_mode = this.getUrlParameter("pm");
    if (play_mode == "1") {
      $(".playmode_1").remove();
      $(".playmode_3").remove();
    }

    if (play_mode == "3") $(".hide-in-playmode_3").remove();

    GigyaManager.getLoggedUserCached().then(
      async (u) => {
        $("#email").val(u.profile.email);

        if (u.profile.firstName && u.profile.lastName) {
          $("#nome").val(u.profile.firstName);
          $("#cognome").val(u.profile.lastName);
        }

        $('input[name="storeType"]').change((e) => {
          let val = $('input[name="storeType"]:checked').val();
          this.buildDropdownStore(
            val == "offline" ? storeOffline : storeOnline
          );
        });
        this.buildDropdownStore(storeOffline);
        this.buildDropdownProduct();
        await this.buildDropdownProvince();

        $("#provincia").change(() => {
          this.startLoader();
          this.buildDropdownCities();
        });

        this.removeLoader();
      },
      (err) => {
        window.location.href =
          "/login?urlBack=" +
          window.location.href.replace(window.location.origin, "") +
          "&regSource=" +
          Constants.PROMO_CODE;
      }
    );

    //IMAGE VIEW
    $("#foto-scontrino").change(() => {
      var input = $("#foto-scontrino")[0];
      let file = input.files[0];
      var maxSize = $(input).data("max-size");

      if (maxSize > file.size) {
        this.startLoader();
        RestManager.uploadImage(this.files.length == 0 ? 1 : 2, file).then(
          (data) => {
            let filename_server = data.response.data.filename;
            let idx_file = filename_server.split(".")[0];
            var reader = new FileReader();
            reader.onload = function (e) {
              if (filename_server.match(/pdf$/)) {
                $(".file-list").append(
                  '<div class="row" id="' +
                    idx_file +
                    '"><div class="figure"><img' +
                    ' src="/fe-web/img/icons/avatar_placeholder.jpg"></div><div' +
                    ' class="file-name">' +
                    file.name +
                    '</div><div class="delete-file" component-click="removeFile(\'' +
                    idx_file +
                    "')\"></div></div>"
                );
              } else {
                $(".file-list").append(
                  '<div class="row" id="' +
                    idx_file +
                    '"><div class="figure"><img src="' +
                    e.target.result +
                    '"></div><div class="file-name">' +
                    file.name +
                    '</div><div class="delete-file" component-click="removeFile(\'' +
                    idx_file +
                    "')\"></div></div>"
                );
              }
            };
            reader.readAsDataURL(file);
            this.files.push(filename_server);
            if (this.files.length == 2) {
              $("#foto-scontrino").prop("disabled", true);
              $(".carica-scontrino").addClass("disabled");
            }
            $("#foto-scontrino").val("");
            this.removeLoader();
          },
          (resp) => {
            $("#foto-scontrino").val("");
            this.removeLoader();
          }
        );
      } else {
        $("#foto-scontrino").addClass("error");
        $(".custom-row--middle").append(
          '<span class="error-feedback"><span' +
            ' class="icon-error">!</span> Il file caricato è troppo grande</span>'
        );
      }
    });
  }

  buildDropdownStore(stores) {
    let options = '<option value="-" default="true">Scegli lo store</option>';

    let storeList = stores.response.data;
    for (var i = 0; i < storeList.length; i++) {
      options += `<option value="${storeList[i].tag}">${storeList[i].description}</option>`;
    }

    $("#market").html(options);
    $("#market").val("-");
  }

  buildDropdownProduct() {
    let options = "";

    let productList = productData.response.data;
    for (var i = 0; i < productList.length; i++) {
      options += `<option value="${productList[i].code}">${productList[i].description}</option>`;
    }

    $("#product").html(
      '<option value="0" default="true">Scegli il prodotto Numero1</option>' +
        options
    );
    $("#product2").html(
      '<option value="0" default="true">Scegli il prodotto Numero2</option>' +
        options
    );
    $("#product").val(0);
    $("#product2").val(0);
  }

  async buildDropdownProvince() {
    let options =
      '<option value="" default="true">Scegli la provincia</option>';

    let resp = await RestManager.getProvinces();
    let provinceList = resp.response.data;
    for (var i = 0; i < provinceList.length; i++) {
      options += `<option value="${provinceList[i].id}" data-province-short-desc="${provinceList[i].short_description}" data-region-id="${provinceList[i].region.id}">${provinceList[i].description}</option>`;
    }

    $("#provincia").html(options);
    $("#provincia").val("");
  }

  async buildDropdownCities() {
    let options = '<option value="" default="true">Scegli la città</option>';

    let resp = await RestManager.getCities($("#provincia").val());
    let provinceList = resp.response.data;
    for (var i = 0; i < provinceList.length; i++) {
      options += `<option value="${provinceList[i].id}" >${provinceList[i].description}</option>`;
    }

    $("#citta").html(options);
    $("#citta").val("");
    this.removeLoader();
  }

  submit() {
    this.startLoader();
    this.validateForm();
  }
  sendForm() {
    let inputs = $(".col-form > input, .col-form #citta, .col-form #provincia");
    let form = {
      basedata: {
        play_token: this.getUrlParameter("pt"),
      },
      customdata: {},
    };
    for (let i = 0; i < inputs.length; i++) {
      let input = $(inputs[i]);
      if (input.attr("id") != "foto-scontrino") {
        form.basedata[input.attr("name")] = input.val();
      }
    }

    if (this.getUrlParameter("pm") == "3") {
      form.customdata["products"] = [
        { code: $("#product").val(), quantity: 1 },
        { code: $("#product2").val(), quantity: 1 },
      ];

      form.customdata["store"] = $("#online").prop("checked")
        ? "iperdrive.it"
        : "finiper";

      form.basedata["receipt_file_front"] = this.files[0];
      if (this.files.length > 1) {
        form.basedata["receipt_file_back"] = this.files[1];
      }
    }

    RestManager.prizeRequest(form).then(
      (resp) => {
        window.location.href =
          "/promozioni/dona-felicita-a-colazione-finiper/thank-you";
      },
      (err) => {
        this.removeLoader();
        let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>${err.status.errors.data.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
        $(this.element).append(tmplModalGeneric);
        this.loadChildComponents(this);
      }
    );
  }
  getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  removeFile(idx) {
    $("#" + idx).remove();
    for (let i = 0; i < this.files.length; i++) {
      if (this.files[i].indexOf(idx) != -1) {
        this.files.splice(i, 1);
      }
    }
    if (this.files.length == 2) {
      $("#foto-scontrino").prop("disabled", true);
      $(".carica-scontrino").addClass("disabled");
    } else {
      $("#foto-scontrino").prop("disabled", false);
      $(".carica-scontrino").removeClass("disabled");
    }
  }

  removeLoader() {
    $(".tool_loader").fadeOut(500).remove();
    $("body").removeClass("noScroll");
    $("#conferma").prop("disabled", false).removeClass("disabled");
  }

  startLoader() {
    $(".mb-finiper-felicita2020").append(
      '<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>'
    );
    $("body").addClass("noScroll");
    $("#conferma").prop("disabled", true).addClass("disabled");
  }

  showProgressiveProfiling() {
    $(".progressive-profiling-modal-cnt").show();
    $("body").addClass("noScroll");
  }

  validateForm() {
    $(".error-feedback").remove();
    $("input, select").removeClass("error");

    var varNome = this.take_nome();
    var varCognome = this.take_cognome();
    var varTelefono = this.take_telefono();
    /*    var varCap = this.take_cap();
    var varIndirizzo = this.take_indirizzo();
    var varCivico = this.take_ncivico();
    var varCitta = this.take_citta();
    var varProvincia = this.take_provincia(); */

    var varStore = this.take_market();
    var varReceipt_product_code = this.take_product();
    var varReceipt_product2_code = this.take_product2();

    var varFiles = $("#foto-scontrino").length == 0 || this.files.length > 0;

    var varPrizeDestination = $("#prize-destination").length
      ? $("#prize-destination")[0].checked
      : false;

    if (!varFiles) {
      $("#foto-scontrino").addClass("error");
      $(".custom-row--middle").append(
        '<span class="error-feedback"><span' +
          ' class="icon-error">!</span> Devi caricare almeno una foto dello scontrino!</span>'
      );
    }

    if (
      varNome &&
      varCognome &&
      varTelefono &&
      /*    varCap &&
      varIndirizzo &&
      varCivico &&
      varCitta &&
      varProvincia && */
      varStore &&
      varReceipt_product_code &&
      varReceipt_product2_code &&
      varFiles
    ) {
      this.showProgressiveProfiling();
      //this.sendForm();
    } else {
      this.removeLoader();
      return false;
    }
  }

  updateProfile(toDoUpdate) {
    $(".progressive-profiling-modal-cnt").hide();
    if (toDoUpdate) {
      let gigyaObj = {
        profile: {
          firstName: $("#nome").val(),
          lastName: $("#cognome").val(),
          //city: $("#citta option:selected").text(),
          //address: $("#indirizzo").val() + " " + $("#ncivico").val(),
          //zip: $("#cap").val(),
        },
        data: {
          MobilePhone: $("#telefono").val(),
          /* COD_PROVINCE: $("#provincia option:selected").data(
            "provinceShortDesc"
          ), */
        },
        callback: (data) => {
          if (data.status == "OK") {
            this.sendForm();
          } else {
            console.log(e);
            this.removeLoader();
            let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>Errore durante l'aggiornamento dei campi del profilo.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
            $(this.element).append(tmplModalGeneric);
            this.loadChildComponents(this);
          }
        },
      };

      GigyaManager.setAccountInfo(gigyaObj);
    } else {
      this.sendForm();
    }
  }

  take_market() {
    if ($("#market").length) {
      var market = $("#market").val();
      if ((market.length < 2) & (market !== undefined)) {
        $("#market").addClass("error");
        $(".row-form--market").append(
          '<span class="error-feedback"><span class="icon-error">!</span> Il campo deve essere selezionato</span>'
        );
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  take_product() {
    if ($("#product").length) {
      var product = $("#product").val();
      if ((product.length < 2) & (product !== undefined)) {
        $("#product").addClass("error");
        $(".row-form--product").append(
          '<span class="error-feedback"><span class="icon-error">!</span> Il campo Prodotto1 deve essere selezionato</span>'
        );
      } else {
        var productArr = productData.response.data.map((o) => o.code);
        if (productArr.indexOf(product) >= 0) {
          return true;
        } else {
          $("#product").addClass("error");
          $(".row-form--product").append(
            '<span class="error-feedback"><span class="icon-error">!</span> Il campo Prodotto1 deve essere selezionato</span>'
          );
        }
      }
    } else {
      return true;
    }
  }

  take_product2() {
    if ($("#product2").length) {
      var product = $("#product2").val();
      if ((product.length < 2) & (product !== undefined)) {
        $("#product").addClass("error");
        $(".row-form--product").append(
          '<span class="error-feedback"><span class="icon-error">!</span> Il campo Prodotto2 deve essere selezionato</span>'
        );
      } else {
        var productArr = productData.response.data.map((o) => o.code);
        if (productArr.indexOf(product) >= 0) {
          return true;
        } else {
          $("#product").addClass("error");
          $(".row-form--product").append(
            '<span class="error-feedback"><span class="icon-error">!</span> Il campo Prodotto2 deve essere selezionato</span>'
          );
        }
      }
    } else {
      return true;
    }
  }

  take_nome() {
    if ($("#nome").length) {
      var nome = $("#nome").val();
      if ((nome.length < 2) & (nome !== undefined)) {
        $("#nome")
          .addClass("error")
          .after(
            '<span class="error-feedback"><span' +
              ' class="icon-error">!</span> Il campo deve essere compilato</span>'
          );
      } else {
        var validName = this.regexNomi.test(nome);
        if (!validName) {
          $("#nome")
            .addClass("error")
            .after(
              '<span class="error-feedback"><span' +
                ' class="icon-error">!</span> Il campo deve essere composto solo da' +
                " caratteri alfanumerici</span>"
            );
        } else {
          return true;
        }
      }
    } else {
      return true;
    }
  }

  take_cognome() {
    if ($("#cognome").length) {
      var cognome = $("#cognome").val();
      if ((cognome.length < 2) & (cognome !== undefined)) {
        $("#cognome")
          .addClass("error")
          .after(
            '<span class="error-feedback"><span' +
              ' class="icon-error">!</span> Il campo deve essere compilato</span>'
          );
      } else {
        var validCognome = this.regexNomi.test(cognome);
        if (!validCognome) {
          $("#cognome")
            .addClass("error")
            .after(
              '<span class="error-feedback"><span' +
                ' class="icon-error">!</span> Il campo deve essere composto solo da' +
                " caratteri alfanumerici</span>"
            );
        } else {
          return true;
        }
      }
    } else {
      return true;
    }
  }

  take_telefono() {
    if ($("#telefono").length) {
      var telefono = $("#telefono").val();
      if ((telefono.length < 2) & (telefono !== undefined)) {
        $("#telefono")
          .addClass("error")
          .after(
            '<span class="error-feedback"><span' +
              ' class="icon-error">!</span> Il campo deve essere compilato</span>'
          );
      } else {
        var validTel = this.numberReg.test(telefono);
        if (!validTel) {
          $("#telefono")
            .addClass("error")
            .after(
              '<span class="error-feedback"><span' +
                ' class="icon-error">!</span> Il campo deve essere composto' +
                " solo da" +
                " caratteri numerici</span>"
            );
        }
        return true;
      }
    } else {
      return true;
    }
  }

  take_cap() {
    if ($("#cap").length) {
      var cap = $("#cap").val();
      if ((cap.length < 2) & (cap !== undefined)) {
        $("#cap")
          .addClass("error")
          .after(
            '<span class="error-feedback"><span' +
              ' class="icon-error">!</span> Il campo deve essere compilato</span>'
          );
      } else {
        var validCap = this.capReg.test(cap);
        const capNumber = this.numberReg.test(cap);
        if (!validCap && !capNumber) {
          $("#cap")
            .addClass("error")
            .after(
              '<span class="error-feedback"><span' +
                ' class="icon-error">!</span> Il campo deve essere composto' +
                " da " +
                "5 caratteri numerici</span>"
            );
        } else {
          return true;
        }
      }
    } else {
      return true;
    }
  }

  take_ncivico() {
    if ($("#ncivico").length) {
      var ncivico = $("#ncivico").val();
      if ((ncivico.length < 1) & (ncivico !== undefined)) {
        $("#ncivico")
          .addClass("error")
          .after(
            '<span class="error-feedback"><span' +
              ' class="icon-error">!</span> Il campo deve essere compilato</span>'
          );
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  take_indirizzo() {
    if ($("#indirizzo").length) {
      var indirizzo = $("#indirizzo").val();
      if ((indirizzo.length < 2) & (indirizzo !== undefined)) {
        $("#indirizzo")
          .addClass("error")
          .after(
            '<span class="error-feedback"><span' +
              ' class="icon-error">!</span> Il campo deve essere compilato</span>'
          );
      } else {
        var valid = this.regexAddress.test(indirizzo);
        if (!valid) {
          $("#indirizzo")
            .addClass("error")
            .after(
              '<span class="error-feedback"><span' +
                ' class="icon-error">!</span> Il campo contiene caratteri non consentiti!</span>'
            );
        } else {
          return true;
        }
      }
    } else {
      return true;
    }
  }

  take_citta() {
    if ($("#citta").length) {
      var citta = $("#citta").val();
      if ((citta == "") & (citta !== undefined)) {
        $("#citta").addClass("error");
        $("#citta")
          .parent(".pp-dropdown-cnt")
          .after(
            '<span class="error-feedback"><span' +
              ' class="icon-error">!</span> Il campo deve essere compilato</span>'
          );
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  take_provincia() {
    if ($("#provincia").length) {
      const $provincia = $("#provincia");
      if (!$provincia.val()) {
        $provincia
          .addClass("error")
          .parent(".pp-dropdown-cnt")
          .after(
            '<span class="error-feedback"><span' +
              ' class="icon-error">!</span> Il campo deve essere compilato</span>'
          );
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}

export default CompletaDatiCtrl;
